module.exports = __webpack_public_path__ + "img/IAR16.02c6e85d.png";